<template>
    <transition name="fade">
        <div class="MeetingRegister" v-show="meetingRegisterVisible" @click="toggleMeetingRegister()">
            <div class="mr-container" @click="$event.stopPropagation()">

                    <div v-if="!registrationDone">
                        <h1 class="mr-title">{{ $t('Termin Registrierung') }}</h1>
                        <div class="mr-rows" :key="test">
                            <div class="mr-column" v-for="i in 3" :key="i">
                                <p class="mr-date">{{(i == 1 ? "27" : i == 2 ? "28" : "29") + ".9.2021"}}</p>
                                <div class="mr-option" v-for="option in options" :key="option.title">
                                    <p class="mr-option-title">{{ $t(option.title)}}</p>
                                    <p class="mr-option-title2">{{ $t(option.title2)}}</p>
                                    <button :class="{'mr-option-button-active': option.checked[0+i*3]}" class="mr-option-button" @click="checkOption(option,0+i*3)">{{option.time[0]}}</button>	
                                    <button :class="{'mr-option-button-active': option.checked[1+i*3]}" class="mr-option-button" @click="checkOption(option,1+i*3)">{{option.time[1]}}</button>	
                                    <button :class="{'mr-option-button-active': option.checked[2+i*3]}" class="mr-option-button" @click="checkOption(option,2+i*3)">{{option.time[2]}}</button>	
                                </div>
                            </div>
                        </div>

                        <div style="text-align: center; font-size: 18px; margin-bottom: 30px;" v-if="type != 'Register4'">
                            <input type="radio" id="präsenz" name="fav_language" style="margin-right: 10px">
                            <label for="präsenz">{{ $t('Ich nehme vor Ort in Präsenz teil')}}</label><br>
                            <input type="radio" id="online" name="fav_language" checked  style="margin-right: 10px">
                            <label for="online">{{ $t('Ich nehme online teil')}}</label><br>
                        </div>
                      
                        <p style="font-size: 15px;">{{$t('Danke für Ihr Interesse, wir freuen uns auf Sie!')}}</p>
                        <button class="mr-register-button" @click="register()">{{ $t('Termin vereinbaren') }}</button>
                    </div>
                    
                    <div v-else class="mr-success">
                        <Check/>
                        <span>{{ $t('Terminvereinbarung erfolgreich!') }}</span>
                    </div>

                
            </div>         
        </div>  
    </transition>
</template>

<style scoped>
    .MeetingRegister{
        width: 100%;
        height: 100%; 
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2;
        background: #000000d0;
        text-align: center;
    }
    .mr-container{
        position: absolute;
        margin-top: 0px;
        background: white;
        border-radius: 10px;
        transition: width .4s ease, height .4s ease;
        padding-left: 30px;
        padding-right: 30px;
        padding-bottom: 20px;
        max-width: 85%;
        max-height: 90%;
        overflow: auto;
    }
    .mr-title{
        margin-top: 50px;
        margin-bottom: 30px;
        font-size: 40px;
        font-weight: bold;
    }
    .mr-rows{
        display: flex;
	    flex-wrap: wrap;
    }
    .mr-column{
        flex-grow: 1;
        width: 30%;
        margin-left: 20px;
        margin-right: 20px;
    }
    .mr-date{
        font-size: 25px;
        margin-bottom: 30px;
        font-weight: bold;
    }
    .mr-option{
        margin-bottom: 60px;
    }
    .mr-option-title{
        font-size: 20px;
        margin-bottom: 10px;
    }
    .mr-option-title2{
        font-size: 14px;
        font-style: italic;
    }
    .mr-option-button{
        background-color: #046976;
        color: white;
        padding: 10px 15px;
        margin-left: 5px;
        margin-right: 5px;
        margin-bottom: 5px;
        font-size: 16px;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        opacity: 0.4;
    }
    .mr-option-button-active{
        opacity: 1;
    }
    .mr-option-button:hover{
        opacity: 1;
    }
    .mr-option-button:active{
        background-color: #00515e;
    }
    .mr-register-button{
        width: 25%;
        background-color: #00545f;
        color: white;
        font-size: 18px;
        padding: 14px 20px;
        margin: 20px;
        margin-top: 0px;
        border: none;
        border-radius: 4px;
        cursor: pointer;
    }
    .mr-register-button:hover{
        background-color: #00424b;
    }
    .mr-register-button:active{
        background-color: #00545f;
    }
    .mr-success{
        font-size: 18px;
        margin: 10px;
        padding: 15px;
        padding-top: 20px;
        color: green;
        border-radius: 5px;
        white-space: pre-wrap; 
        word-wrap: break-word;
    }

    .mr-success .material-design-icon{
        display: block;
        margin: auto;
        height: 50px !important;
        width: 50px !important;
        text-align: left;
    }
    .mr-success .material-design-icon > .material-design-icon__svg {
        height: 50px !important;
        width: 50px !important;
        fill: green;
    }
</style>
    
<script>
import {mapGetters,mapMutations} from 'vuex';
import Check from 'vue-material-design-icons/Check.vue'
import axios from "axios";
export default {
    components: {Check},
    inject: ['toggleLoginDialogue'],
    data: function () {
        return {
            meetingRegisterVisible: false,
            type: null,
            registrationDone: false,
            test: 0,

            allOptions: [
                [
                    {
                        title: "Einstieg in die automatisierte Beschichtung",
                        title2: "VEN SPRAY ONE Lackiervorführung mit 1-K-Lack",
                        time: ["09:00 h","12:00 h","15:00 h"],
                        checked: [false,false,false,false,false,false,false,false,false]
                    },
                    {
                        title: "Excimer Technologie",
                        title2: "VEN SPRAY PERFECT u. diverse Trocknungstechnik",
                        time: ["09:30 h","12:30 h","15:30 h"],
                        checked: [false,false,false,false,false,false,false,false,false]
                    }
                ],

                [
                    {
                        title: "Automatisierungstechnik",
                        title2: "Produktionsprozesse beschleunigen und vereinfachen durch intelligente Fördertechnik",
                        time: ["10:00 h","13:00 h","16:00 h"],
                        checked: [false,false,false]
                    },
                    {
                        title: "Objekttüren nach Maß",
                        title2: "Beispiel einer Produktionslinie mit hohem Automatisierungsgrad für Türenbeschichtung",
                        time: ["10:20 h","13:20 h","16:20 h"],
                        checked: [false,false,false]
                    },
                    {
                        title: "Möbelbeschichtung",
                        title2: "Individuelle Beschichtungslösungen für unterschiedliche Ansprüche",
                        time: ["10:40 h","13:40 h","16:40 h"],
                        checked: [false,false,false]
                    }
                ],

                [
                    {
                        title: "Geführter Rundgang",
                        title2: "Geführte 360° Touren um Referenzanlagen in unserem virtuellen Showroom",
                        time: ["11:00 h","14:00 h","17:00 h"],
                        checked: [false,false,false]
                    }
                ],

                 [
                    {
                        title: "Persönliche Beratung",
                        title2: "Vereinbaren Sie Ihr individuelles Beratungsgespräch. Direkt vor Ort, oder online",
                        time: ["09:00 h - 12:00 h","12:00 h - 15:00 h","15:00 h - 18:00 h"],
                        checked: [false,false,false]
                    }
                ]

            ]
        }
    }, 
    computed: {
        ...mapGetters(['logoURL','localUserID','moderatorMode','loggedIn']),
        options(){
            switch (this.type) {
                case "Register1":
                    return this.allOptions[0];
                case "Register3":
                    return this.allOptions[1];
                case "Register4":
                    return this.allOptions[2];
                case "Register5":
                    return this.allOptions[3];
                default:
                    break;
            }
        }
    },
	methods: {       
        ...mapMutations(["setDialogueOpen","setStopModeratorModeSignals"]),
        toggleMeetingRegister(){
            this.meetingRegisterVisible = !this.meetingRegisterVisible;
            setTimeout(() => {
                this.registrationDone = false;
            }, 400);
        },
        initDialogue(e){
            if(this.loggedIn){
                this.type = e.detail.type;
                this.toggleMeetingRegister();
            }
        },
        checkOption(option,index){
            option.checked[index] = !option.checked[index];
            this.test++;
        },
        register(){
            let meetings = [];
            let id=0;
            this.allOptions.forEach(option => {
                option.forEach(meeting => {
                    id++;

                    for (let i = 0; i < meeting.checked.length; i++) {
                        if(meeting.checked[i]){
                            meetings.push({
                                "id": id,
                                "name": meeting.title,
                                "time": meeting.time[i%3],
                                "date": i < 6 ? "27.09.2021" : i < 9 ? "28.09.2021" : "29.09.2021",
                                "user": "test",
                                "online": !document.getElementById("online") ? " " : document.getElementById("online").checked ? "online" : "präsenz",
                            })
                            meeting.checked[i] =false;
                        }
                    }
                });
            });

            meetings.forEach((item)=>{
                const options = {
                    method: 'POST',
                    url: 'https://auth.ar-cms.de/api/vrm/tracking',
                    headers: {
                        'Content-Type': 'application/json',
                        location: '/eventregistration',
                        Authorization: 'Bearer '+localStorage.getItem("accessToken"),
                        location: "/termin"
                    },
                    data: item
                    };

                    axios.request(options).then(function (response) {
                        console.log(response.data);
                    }).catch(function (error) {
                        console.error(error);
                    });
            });

            this.registrationDone = true;
            setTimeout(() => {
                this.toggleMeetingRegister();
            }, 3000);
        }
    },
    mounted: function(){
        window.addEventListener('openMeetingRegister',this.initDialogue);
    }
}

</script>